import { render, staticRenderFns } from "./personalEditDialog.vue?vue&type=template&id=2d52fb3f&scoped=true"
import script from "./personalEditDialog.vue?vue&type=script&lang=js"
export * from "./personalEditDialog.vue?vue&type=script&lang=js"
import style0 from "./personalEditDialog.vue?vue&type=style&index=0&id=2d52fb3f&prod&lang=scss&scoped=true"
import style1 from "./personalEditDialog.vue?vue&type=style&index=1&id=2d52fb3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52fb3f",
  null
  
)

export default component.exports